import RecaptchaWrapper from "./captcha-wrapper";
import ForterCaptcha from "./forter-captcha";

export default RecaptchaWrapper;
export { ForterCaptcha };